export default {
    header: {
        profile: 'Profile',
        exit: 'Exit',
    }
}
